document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.content-card-packing').forEach((el) => {
    const wrap = el.closest('.content-slider-packing') || el;
    new Swiper(el, {
      slidesPerView: 1,
      spaceBetween: 10,
      pagination: {
        el: el.querySelector('.swiper-pagination'),
        clickable: true,
      },
      navigation: {
        nextEl: wrap.querySelector('.swiper-button-next'),
        prevEl: wrap.querySelector('.swiper-button-prev'),
      },
      breakpoints: {
        568: {
          slidesPerView: 2,
          spaceBetween: 10,
        },
        768: {
          slidesPerView: 3,
          spaceBetween: 10,
        },
        992: {
          slidesPerView: 4,
          spaceBetween: 20,
        },
      },
    });
  });
});
